module.exports = "/static/assets/0b7f8bdc3a1bdb087034873a07168d76.png";